import Vue from "vue";

const providers = {
  google: {
    authorizationEndpoint: "/api/v1/auth/google_oauth2",
  },
  facebook: {
    authorizationEndpoint: "/api/v1/auth/facebook",
  },
  twitter: {
    authorizationEndpoint: "/api/v1/auth/twitter",
  },
  linkedin: {
    authorizationEndpoint: "/api/v1/auth/linkedin",
  },
};

Vue.prototype.$auth = {
  async authenticate(provider) {
    return new Promise((resolve, reject) => {
      const { authorizationEndpoint } = providers[provider];
      localStorage.removeItem("token");

      const w = window.open(
        authorizationEndpoint,
        "Auth",
        "width=580,height=730"
      );
      const interval = setInterval(() => {
        const token = localStorage.getItem("token");

        if (token) {
          resolve({ token });

          clearInterval(interval);
          w.close();
          return;
        }

        if (w.closed) {
          reject();
        }
      }, 250);
    });
  },
};
